import { render } from "./HorsePendingView.vue?vue&type=template&id=51e04276&scoped=true"
import script from "./HorsePendingView.vue?vue&type=script&lang=js"
export * from "./HorsePendingView.vue?vue&type=script&lang=js"

import "./HorsePendingView.vue?vue&type=style&index=0&id=51e04276&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e04276"]])

export default __exports__